
<div *ngIf="!captchaVerified && standaloneMode && !newUserMode" style="width: 100%; display: flex; justify-content: center;">
    <re-captcha (resolved)="resolvedRecaptcha($event)" [siteKey]="siteKey"></re-captcha>
</div>
<div *ngIf="captchaVerified || newUserMode || !standaloneMode">
    <div id="listCard" *ngIf="!loadingCard; else pleaseWait">
        <p *ngIf="cardData === null; else cardDisplay">
            <i class="fal fa-credit-card-blank text-muted me-1"></i>
            You don't have a card saved. Please add one below.
        </p>
        <ng-template #cardDisplay>
            <p class="mb-0">Your card on file:</p>
            <div class="cardRow" [ngClass]="{'disabled': addCardMode}">
                <span *ngIf="!removalConfirmOpen; else removeConfirmText">
                    <i class="fab fa-2x me-3" 
                    style="vertical-align: middle;"
                    [ngClass]="{
                        'fa-cc-visa': cardData.card_brand === 'visa',
                        'fa-cc-mastercard' : cardData.card_brand === 'mc',
                        'fa-cc-amex': cardData.card_brand === 'amex',
                        'fa-cc-discover': cardData.card_brand === 'disc',
                        'fa-cc-diners-club': cardData.card_brand === 'diners',
                        'fa-cc-jcb': cardData.card_brand === 'jcb',
                        'fa-gift-card': cardData.card_brand === 'SQUARE_GIFT_CARD',
                        'fa-credit-card-front': cardData.card_brand === 'OTHER_BRAND'
                        }">
                    </i>
                    **** <strong>{{ cardData.last_4}}</strong> &nbsp; Exp: <span [ngClass]="{'text-danger': ccExpired, 'text-warning': ccAlmostExpired}">{{ cardData.exp_month }}/{{ cardData.exp_year }}</span>
                </span>
                <ng-template #removeConfirmText>
                    Delete {{ cardData.card_brand}} ending in {{ cardData.last_4}}?
                </ng-template>
                <div *ngIf="removalConfirmOpen === false; else removalConfirmBtns" [hidden]="newUserMode" class="btn-group ms-2" role="group">
                    <button class="btn btn-outline-dark" [ngClass]="{'disabled': addCardMode}"
                      type="button" matTooltip="Change card on file" 
                      (click)="replaceCard()">
                        <i class="fad fa-exchange-alt me-1"></i>
                        {{ (ccExpired || ccAlmostExpired) ? 'Update card' : ''}}
                    </button>
                    <button class="btn btn-outline-danger" [ngClass]="{'disabled': addCardMode}"
                     type="button" matTooltip="Remove card"
                      (click)="removalConfirmOpen = true">
                        <i class="fal fa-trash me-1"></i>
                    </button>
                </div>
                <ng-template #removalConfirmBtns>
                    <div class="btn-group ms-2" role="group">
                        <button class="btn btn-primary"
                         type="button" 
                         (click)="removalConfirmOpen = false">
                            No
                        </button>
                        <button class="btn btn-danger"
                         type="button"
                          (click)="removeCard()">
                            Yes
                        </button>
                    </div>
                </ng-template>
            </div>
            <div class="alert-danger p-1 mt-1" *ngIf="ccExpired">
                <i class="fal fa-exclamation-circle text-danger me-1"></i>
                Your card is expired. 
                <br>Please update your payment details.
            </div>
            <div class="alert-warning p-1 mt-1" *ngIf="ccAlmostExpired">
                <i class="fal fa-exclamation-triangle me-1" style="color: black;"></i>
                Your card expires soon.
                <br>Please update your payment details.
            </div>
        </ng-template>
    </div>

    <ng-template #pleaseWait>
        <div class="loader-filters text-center">
            <div class="loader-filters-inner ball-grid-pulse">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <br>
    </ng-template>

    <form [collapse]="!addCardMode" [isAnimated]="true" id="payment-form" [ngClass]="{'dark-mode': darkMode}">
        <h5>{{ cardData ? 'Replace your card on file' : 'Add your card' }}</h5>
        <h6>Please enter your payment information</h6>
        <div id="payment"></div> <!-- <== Fortis card form inserts here. -->
        <button id="save-card-button" [disabled]="processingCard" class="sq" type="submit" (click)="fortisCard.submit()" matTooltip="This will save your card on file with Fortis" [matTooltipShowDelay]="tooltipDelay">
          {{ standaloneMode ? 'Save card' : 'Next' }}
          <i style="color: black;" class="fal fa-spin fa-spinner-third ms-1" *ngIf="processingCard"></i>
        </button>
        <button *ngIf="cardData !== null" [disabled]="processingCard" class="sq sq-cancel" (click)="cancelAddCard()">
            Cancel
        </button>
    </form>
    <span class="small">
        <i class="fal fa-sm fa-lock me-1"></i>All cards are securely saved with Fortis
    </span>
    <h6 *ngIf="!standaloneMode">
        You will be able to enter discount codes and review your purchase in the next step.
    </h6>
</div>
